'use strict';
(()=>{
 const script=document.currentScript;
 const draftId=String(script?.dataset.marcoThemeId||'');
 const allowedDraftIds=new Set(['201631826303','183672734079']);
 const role=script?.dataset.marcoThemeRole;
 const active=role==='unpublished'&&allowedDraftIds.has(draftId);
 function draftURL(path){
  if(typeof path!=='string'||!path.trim())return '';
  try{
   const url=new URL(path,location.origin);
   if(url.origin!==location.origin||!['https:','http:'].includes(url.protocol))return '';
   if(active)url.searchParams.set('preview_theme_id',draftId);
   const language=window.MARCOLanguage?.language;
   if(['de','en'].includes(language))url.searchParams.set('language',language);
   return url.pathname+url.search+url.hash;
  }catch(error){return '';}
 }
 window.marcoDraftURL=draftURL;
 function rewrite(link){
  const original=link.getAttribute('href');
  if(!original||original.startsWith('#'))return;
  const path=draftURL(original);
  if(path)link.setAttribute('href',path);
 }
 document.querySelectorAll('a[href]').forEach(rewrite);
 document.addEventListener('click',event=>{
  const link=event.target.closest?.('a[href]');
  if(link)rewrite(link);
 },true);
 document.addEventListener('submit',event=>{
  const form=event.target;
  if(form.tagName!=='FORM'||form.method.toLowerCase()!=='get')return;
  const action=draftURL(form.getAttribute('action')||location.pathname);
  if(!action)return;
  if(active){
   let field=form.querySelector('input[name="preview_theme_id"]');
   if(!field){field=document.createElement('input');field.type='hidden';field.name='preview_theme_id';form.append(field);}
   field.value=draftId;
  }
  const language=window.MARCOLanguage?.language;
  if(['de','en'].includes(language)){
   let languageField=form.querySelector('input[name="language"]');
   if(!languageField){languageField=document.createElement('input');languageField.type='hidden';languageField.name='language';form.append(languageField);}
   languageField.value=language;
  }
 },true);
 document.addEventListener('marco:language',()=>document.querySelectorAll('a[href]').forEach(rewrite));
})();
